// All 9 service pages with deep SEO content
export const SERVICES = [
  {
    slug: "dental-implants-allahabad",
    name: "Dental Implants",
    shortName: "Implants",
    icon: "Anchor",
    seoTitle:
      "Best Dental Implants in Allahabad | Painless Implantologist – Lotus Family Dental",
    metaDescription:
      "Get permanent, natural-looking dental implants in Allahabad at Lotus Family Dental. Certified Osstem implantologist, lifetime warranty, EMI options. Book today.",
    h1: "Best Dental Implants in Allahabad",
    tagline: "Permanent. Painless. Lifetime Warranty.",
    coverImage:
      "https://i.pinimg.com/736x/05/29/ee/0529ee7b5b8064fd7998039165a1496b.jpg",
    intro:
      "Missing a tooth or wearing uncomfortable dentures? Dental implants at Lotus Family Dental are the gold standard for tooth replacement in Allahabad. Our certified Osstem implantologist Dr. Rahul Tiwari has placed thousands of implants — restoring smiles and bite function permanently. Walk in for a free consultation today.",
    symptoms: [
      "One or more missing teeth",
      "Loose or ill-fitting dentures",
      "Difficulty chewing on one side",
      "Shifting of adjacent teeth into the gap",
      "Bone loss in the jaw area",
      "Sunken facial appearance",
    ],
    process: [
      {
        title: "Free Consultation & 3D Imaging",
        text: "We assess your bone, gums and bite with digital X-rays and a CBCT scan to design your implant plan.",
      },
      {
        title: "Painless Implant Placement",
        text: "Under local anaesthesia, a titanium implant is precisely placed in 30–45 minutes. Most patients return to work the same day.",
      },
      {
        title: "Healing Period (Osseointegration)",
        text: "Your jawbone fuses with the implant over 3–4 months — creating a rock-solid foundation.",
      },
      {
        title: "Custom Crown Fitting",
        text: "A natural-looking zirconia or PFM crown is fitted on the implant. The result feels and functions like a real tooth.",
      },
    ],
    benefits: [
      "Lasts a lifetime with proper care",
      "Prevents bone loss in the jaw",
      "Eat anything — no diet restrictions",
      "Looks & feels exactly like a real tooth",
      "Does not damage adjacent teeth",
      "Certified Osstem implants used",
    ],
    faqs: [
      {
        q: "How much does a dental implant cost in Allahabad?",
        a: "At Lotus Family Dental, single tooth dental implants in Allahabad start from ₹18,000 and go up to ₹55,000 depending on the implant system (Osstem, Nobel, Straumann), bone grafting requirements, and crown material. EMI options are available.",
      },
      {
        q: "Is dental implant surgery painful?",
        a: "No. The procedure is done under local anaesthesia and is completely painless. Most patients report less discomfort than a routine tooth extraction. Mild soreness for 2–3 days is normal and easily managed with prescribed medication.",
      },
      {
        q: "How long do dental implants last?",
        a: "Dental implants are designed to last a lifetime. With proper oral hygiene and 6-monthly check-ups, the implant body can serve you for 25+ years. We provide a written warranty on every Osstem implant placed at our Prayagraj clinic.",
      },
      {
        q: "How many visits are needed?",
        a: "Typically 3–4 visits over 3–4 months. First visit for diagnosis, second for implant placement, third for impressions after healing, and fourth for final crown fitting.",
      },
    ],
  },
  {
    slug: "root-canal-treatment-allahabad",
    name: "Root Canal Treatment",
    shortName: "Root Canal",
    icon: "Activity",
    seoTitle:
      "Painless Root Canal Treatment in Allahabad | Single Sitting RCT Specialist",
    metaDescription:
      "Painless single-sitting root canal treatment in Allahabad. Save your natural tooth with our RCT specialist at Lotus Family Dental. Book today.",
    h1: "Painless Root Canal Treatment in Allahabad",
    tagline: "Save Your Tooth. Single Sitting Available.",
    coverImage:
      "https://i.pinimg.com/736x/6e/eb/b1/6eebb111f64b0c8976e5a56367bbea8e.jpg",
    intro:
      "Suffering from severe tooth pain or sensitivity? You may need a root canal treatment. At Lotus Family Dental in Allahabad, our RCT specialist Dr. Monika Tiwari uses advanced rotary endodontics to deliver pain-free, single-sitting root canal treatment. Save your natural tooth — no extraction needed.",
    symptoms: [
      "Severe throbbing tooth pain",
      "Sensitivity to hot or cold (lingering pain)",
      "Pain while chewing",
      "Tooth discolouration",
      "Swollen, tender gums near a tooth",
      "Pimple-like bump on the gum",
    ],
    process: [
      {
        title: "Digital X-Ray Diagnosis",
        text: "An RVG scan identifies the infected canal and exact treatment plan in minutes.",
      },
      {
        title: "Local Anaesthesia",
        text: "The area is fully numbed — you will not feel any pain during the procedure.",
      },
      {
        title: "Rotary Canal Cleaning",
        text: "Using precision rotary files, the infected pulp is removed and canals are disinfected.",
      },
      {
        title: "Sealing & Crown",
        text: "Canals are sealed with biocompatible material. A custom crown is placed within a week to fully restore the tooth.",
      },
    ],
    benefits: [
      "Saves your natural tooth",
      "Eliminates pain in one sitting",
      "More affordable than implants",
      "Maintains your natural bite",
      "Latest rotary endodontic technology",
      "Lifetime tooth preservation",
    ],
    faqs: [
      {
        q: "What is the cost of root canal treatment in Allahabad?",
        a: "Root canal treatment cost in Allahabad ranges from ₹3,500 to ₹8,500 depending on the tooth (anterior, premolar, molar) and the number of canals. A crown costs an additional ₹2,500 to ₹15,000 based on the material chosen.",
      },
      {
        q: "Is single sitting root canal possible?",
        a: "Yes. For most cases, our RCT specialist completes the entire procedure in a single 60–90 minute sitting using advanced rotary endodontics. Complex multi-canal cases may need a follow-up visit.",
      },
      {
        q: "Will I feel pain during root canal treatment?",
        a: "No. The tooth is numbed completely with local anaesthesia. You may feel slight pressure but no pain. After the procedure, mild soreness for 1–2 days is normal and resolves with prescribed medication.",
      },
      {
        q: "Do I really need a crown after RCT?",
        a: "Yes. A root canal treated tooth becomes brittle. A crown protects the tooth from cracking and ensures it functions like a natural tooth for years. We strongly recommend it within 2 weeks of RCT.",
      },
    ],
  },
  {
    slug: "braces-aligners-allahabad",
    name: "Braces & Aligners",
    shortName: "Braces",
    icon: "AlignCenter",
    seoTitle:
      "Best Braces & Clear Aligners in Allahabad | Invisible Braces Specialist",
    metaDescription:
      "Get perfectly aligned teeth with metal braces, ceramic braces, or invisible aligners at Lotus Family Dental Allahabad. Orthodontist Dr. Rahul Tiwari, EMI available.",
    h1: "Best Braces & Invisible Aligners in Allahabad",
    tagline: "Straight Teeth. Confident Smile.",
    coverImage:
      "https://i.pinimg.com/736x/69/05/20/690520eac20a2b372e3cfac08f6eb156.jpg",
    intro:
      "Crooked teeth, gaps, or bite issues? Our MDS Orthodontist Dr. Rahul Tiwari offers the full range — metal braces, ceramic braces, self-ligating braces, and invisible clear aligners (Invisalign-grade). Get the straight, confident smile you have always wanted at Lotus Family Dental, Allahabad.",
    symptoms: [
      "Crooked or overlapping teeth",
      "Gaps between teeth",
      "Overbite, underbite, or crossbite",
      "Crowded teeth",
      "Difficulty in cleaning teeth",
      "Jaw pain due to misaligned bite",
    ],
    process: [
      {
        title: "Orthodontic Consultation",
        text: "Detailed bite assessment with X-rays, intra-oral photos and impressions to plan your treatment.",
      },
      {
        title: "Treatment Plan & Options",
        text: "Choose from metal braces, ceramic, self-ligating, or invisible aligners — we explain pros, cons & timeline.",
      },
      {
        title: "Bonding / Fitting",
        text: "Braces are bonded to teeth or your custom aligner trays are issued. Painless 30–60 minute appointment.",
      },
      {
        title: "Monthly Adjustments",
        text: "Quick monthly visits (15–20 min) to adjust wires or change aligner trays. Average treatment 12–24 months.",
      },
    ],
    benefits: [
      "MDS Orthodontist with 10+ years experience",
      "All braces types under one roof",
      "Clear aligners almost invisible",
      "Easy EMI options",
      "Free first consultation",
      "Retainers included in package",
    ],
    faqs: [
      {
        q: "What is the cost of braces in Allahabad?",
        a: "Metal braces in Allahabad cost between ₹25,000 and ₹40,000. Ceramic braces cost ₹40,000 to ₹60,000. Self-ligating braces are ₹50,000 to ₹80,000. Clear aligners range from ₹85,000 to ₹2,50,000 based on case complexity.",
      },
      {
        q: "What is the best age for braces?",
        a: "The ideal age is 11–15 years when permanent teeth have erupted and the jaw is still growing. However, adults can also undergo treatment — modern clear aligners and ceramic braces make adult orthodontics discreet and effective.",
      },
      {
        q: "Are clear aligners better than metal braces?",
        a: "Both work effectively. Clear aligners are nearly invisible, removable, and comfortable — best for mild to moderate cases. Metal braces are more affordable and handle complex cases. Our orthodontist will recommend the right option after evaluation.",
      },
      {
        q: "How long does braces treatment take?",
        a: "Average treatment duration is 12 to 24 months depending on case complexity. Mild crowding may finish in 8–10 months, while complex bite corrections may take 24–30 months. Aligners often complete in 10–18 months.",
      },
    ],
  },
  {
    slug: "teeth-whitening-allahabad",
    name: "Teeth Whitening",
    shortName: "Whitening",
    icon: "Sparkles",
    seoTitle:
      "Professional Teeth Whitening in Allahabad | Laser Bleaching – Lotus Family Dental",
    metaDescription:
      "Get a brighter smile in just 45 minutes with professional teeth whitening at Lotus Family Dental Allahabad. Safe, painless, FDA-approved. Book today.",
    h1: "Professional Teeth Whitening in Allahabad",
    tagline: "Up to 8 Shades Whiter — In 45 Minutes.",
    coverImage:
      "https://i.pinimg.com/736x/a9/18/96/a918964f654aed7d3efb2b49bf87e530.jpg",
    intro:
      "Dull, stained, or yellow teeth? Our in-clinic professional teeth whitening uses FDA-approved gels and LED activation to give you a dazzling Hollywood smile in a single 45-minute session. Completely safe, painless, and dramatically more effective than over-the-counter kits.",
    symptoms: [
      "Yellow or grey discoloration",
      "Coffee, tea or wine stains",
      "Tobacco staining",
      "Age-related yellowing",
      "Dull teeth post braces",
      "Pre-wedding smile makeover need",
    ],
    process: [
      {
        title: "Smile Assessment",
        text: "We check the shade and rule out cavities or sensitivity issues before whitening.",
      },
      {
        title: "Scaling & Polishing",
        text: "Plaque and surface stains are removed first for maximum whitening effect.",
      },
      {
        title: "Whitening Gel Application",
        text: "A safe FDA-approved hydrogen peroxide gel is applied to your teeth. Gums are protected with a barrier.",
      },
      {
        title: "LED Activation",
        text: "Special LED light activates the gel — teeth become up to 8 shades whiter in 3 cycles of 15 minutes each.",
      },
    ],
    benefits: [
      "Visible results in one sitting",
      "Up to 8 shades whiter",
      "Completely safe for enamel",
      "Long-lasting (12–18 months)",
      "Painless procedure",
      "Take-home maintenance kit included",
    ],
    faqs: [
      {
        q: "How much does teeth whitening cost in Allahabad?",
        a: "In-clinic professional teeth whitening at Lotus Family Dental costs ₹6,000 to ₹12,000 per session depending on the system used. Take-home whitening trays are also available from ₹4,000.",
      },
      {
        q: "Is teeth whitening safe?",
        a: "Yes, completely safe when performed by a qualified dentist. We use FDA-approved gels and protect your gums with a barrier. Some patients experience mild sensitivity for 24–48 hours, which subsides quickly.",
      },
      {
        q: "How long does teeth whitening last?",
        a: "Results typically last 12 to 18 months. Lifestyle habits — coffee, tea, wine, tobacco — affect longevity. Touch-up sessions every year keep your smile bright. We provide a maintenance kit for at-home upkeep.",
      },
      {
        q: "Will whitening damage my teeth?",
        a: "No. Professional whitening does not damage enamel when done by a trained dentist. Unlike DIY kits, we control the gel concentration and exposure time precisely — making it safe and effective.",
      },
    ],
  },
  {
    slug: "tooth-extraction-allahabad",
    name: "Tooth Extraction",
    shortName: "Extraction",
    icon: "X",
    seoTitle:
      "Painless Tooth Extraction in Allahabad | Wisdom Tooth Removal Specialist",
    metaDescription:
      "Painless tooth extraction & wisdom tooth removal in Allahabad. Same-day appointments, expert oral surgeon. Book at Lotus Family Dental.",
    h1: "Painless Tooth Extraction in Allahabad",
    tagline: "Quick. Painless. Same-Day Appointment.",
    coverImage:
      "https://i.pinimg.com/1200x/3c/e3/9f/3ce39fd87770cb0e0bb7231814003475.jpg",
    intro:
      "When a tooth cannot be saved or a wisdom tooth is causing pain, prompt extraction prevents complications. At Lotus Family Dental, our oral surgeons perform painless tooth extractions and impacted wisdom tooth removal under local anaesthesia — most procedures complete in 15–30 minutes with quick recovery.",
    symptoms: [
      "Severely decayed or broken tooth",
      "Impacted wisdom tooth pain",
      "Loose tooth due to gum disease",
      "Tooth crowding (pre-braces)",
      "Persistent infection",
      "Cracked tooth below gum line",
    ],
    process: [
      {
        title: "X-Ray Evaluation",
        text: "Digital X-ray confirms the position, roots, and surrounding bone — critical for impacted teeth.",
      },
      {
        title: "Local Anaesthesia",
        text: "The area is fully numbed so you feel no pain during the extraction.",
      },
      {
        title: "Gentle Extraction",
        text: "Modern instruments and techniques (luxation, elevator) remove the tooth with minimal trauma to the bone.",
      },
      {
        title: "Aftercare Instructions",
        text: "Written and verbal post-care guidance for fast healing. Painkillers prescribed as needed.",
      },
    ],
    benefits: [
      "Painless under local anaesthesia",
      "Quick 15–30 minute procedure",
      "Wisdom tooth specialist available",
      "Same-day emergency extractions",
      "Sterile, hygienic environment",
      "Affordable transparent pricing",
    ],
    faqs: [
      {
        q: "How much does tooth extraction cost in Allahabad?",
        a: "Simple tooth extraction at Lotus Family Dental costs ₹500 to ₹1,500. Surgical extraction (impacted wisdom tooth) ranges from ₹2,500 to ₹7,000 depending on complexity and the need for stitches.",
      },
      {
        q: "Is tooth extraction painful?",
        a: "No. With local anaesthesia, you feel no pain — only mild pressure. Post-extraction discomfort is normal for 1–2 days and is well-managed with prescribed pain medication.",
      },
      {
        q: "How long does wisdom tooth extraction take to heal?",
        a: "Soft tissue healing takes 7–10 days. Complete bone healing takes 4–6 weeks. Most patients return to work the next day. Follow our aftercare protocol for faster recovery.",
      },
      {
        q: "Should I replace an extracted tooth?",
        a: "Yes, ideally within 3–6 months. Missing teeth cause adjacent teeth to shift and lead to bone loss. We recommend a dental implant or bridge for permanent replacement.",
      },
    ],
  },
  {
    slug: "child-dentistry-allahabad",
    name: "Child Dentistry",
    shortName: "Pediatric",
    icon: "Baby",
    seoTitle:
      "Best Pediatric Dentist in Allahabad | Child Dentistry – Lotus Family Dental",
    metaDescription:
      "Gentle pediatric dentistry in Allahabad. Dr. Monika Tiwari (Gold Medalist Pedodontist) for kids dental care, fluoride, sealants & cavity treatment.",
    h1: "Best Child Dentist in Allahabad",
    tagline: "Gentle Care for Little Smiles.",
    coverImage:
      "https://i.pinimg.com/736x/84/6d/68/846d68d14e745e58894e6e4a1298826d.jpg",
    intro:
      "Children deserve a dentist who understands them. Dr. Monika Tiwari, our gold-medalist pedodontist, creates a fun, fear-free experience for kids aged 1 to 14. From the first dental visit and fluoride application to fillings and habit correction — your child is in expert hands at Lotus Family Dental, Allahabad.",
    symptoms: [
      "Cavities or tooth decay",
      "Tooth pain in children",
      "Thumb sucking habit",
      "Delayed tooth eruption",
      "Teeth grinding (bruxism)",
      "First dental visit (age 1+)",
    ],
    process: [
      {
        title: "Friendly First Visit",
        text: "We let the child explore the chair and tools first — making them comfortable before any treatment.",
      },
      {
        title: "Gentle Examination",
        text: "Painless examination with kid-friendly tools and language. X-rays only if absolutely needed.",
      },
      {
        title: "Treatment with Tell-Show-Do",
        text: "Every step is explained in a kid-friendly way before doing — building trust and reducing fear.",
      },
      {
        title: "Reward & Aftercare",
        text: "Sticker reward at the end, brushing demo for parents, and personalised diet & hygiene plan.",
      },
    ],
    benefits: [
      "Gold-medalist pedodontist",
      "Fear-free child-friendly clinic",
      "Painless laser fillings available",
      "Fluoride and sealants for protection",
      "Habit-breaking appliances",
      "Parent education on diet & hygiene",
    ],
    faqs: [
      {
        q: "At what age should I take my child to the dentist?",
        a: "By age 1 or within 6 months of the first tooth eruption. Early dental visits prevent cavities, identify habits like thumb-sucking, and make children comfortable with dental care for life.",
      },
      {
        q: "How much does children's dental treatment cost in Allahabad?",
        a: "Routine check-ups are free. Fluoride application costs ₹600–₹1,200. Pit and fissure sealants are ₹400–₹800 per tooth. Milk tooth fillings range from ₹800–₹1,500. Pulp therapy ₹1,500–₹3,500.",
      },
      {
        q: "Are milk teeth cavities important?",
        a: "Yes, very important. Untreated milk tooth cavities can cause pain, infection, and damage to the underlying permanent tooth. Early intervention preserves the natural eruption pattern.",
      },
      {
        q: "How do I stop my child's thumb sucking habit?",
        a: "Habits beyond age 4 can affect jaw development. We offer gentle habit-breaking appliances (palatal crib) and behavioural counselling. Early intervention prevents the need for braces later.",
      },
    ],
  },
  {
    slug: "gum-treatment-allahabad",
    name: "Gum Treatment",
    shortName: "Gum Care",
    icon: "Leaf",
    seoTitle:
      "Best Gum Treatment in Allahabad | Periodontist – Lotus Family Dental",
    metaDescription:
      "Specialist gum disease treatment in Allahabad. Scaling, root planing, flap surgery, laser gum treatment at Lotus Family Dental. Painless. Book today.",
    h1: "Specialist Gum Treatment in Allahabad",
    tagline: "Healthy Gums. Lifelong Teeth.",
    coverImage:
      "https://i.pinimg.com/1200x/a3/fe/f4/a3fef4f389be3e97771b067e8ed10413.jpg",
    intro:
      "Bleeding gums, bad breath, or loose teeth? You may have gum disease — the silent destroyer of teeth. Our periodontist at Lotus Family Dental, Allahabad offers complete gum care — from professional scaling and root planing to laser gum treatment and flap surgery. Save your teeth before it is too late.",
    symptoms: [
      "Bleeding while brushing",
      "Bad breath (halitosis)",
      "Red, swollen or tender gums",
      "Receding gum line",
      "Loose teeth",
      "Pus between teeth and gums",
    ],
    process: [
      {
        title: "Periodontal Examination",
        text: "Pocket depth measurement, X-rays and gum health charting to grade the disease.",
      },
      {
        title: "Professional Scaling",
        text: "Ultrasonic scaling removes plaque and tartar from above and below the gum line — painless.",
      },
      {
        title: "Root Planing",
        text: "Deep cleaning of root surfaces to remove bacteria-trapping rough spots — helps gums reattach.",
      },
      {
        title: "Surgical / Laser Therapy",
        text: "For advanced cases, flap surgery or laser gum treatment regenerates lost tissue and saves teeth.",
      },
    ],
    benefits: [
      "Specialist periodontist available",
      "Painless ultrasonic scaling",
      "Laser gum treatment option",
      "Saves loose teeth",
      "Eliminates bad breath",
      "Prevents tooth loss",
    ],
    faqs: [
      {
        q: "How much does scaling cost in Allahabad?",
        a: "Professional ultrasonic scaling and polishing at Lotus Family Dental costs ₹800 to ₹2,000 per session depending on the amount of tartar. We recommend scaling once every 6 months for optimal gum health.",
      },
      {
        q: "Is gum bleeding serious?",
        a: "Yes, it is the first sign of gum disease (gingivitis). If ignored, it progresses to periodontitis — leading to bone loss and tooth loss. Early treatment is simple and effective.",
      },
      {
        q: "Can loose teeth be saved?",
        a: "In many cases, yes. With timely periodontal therapy, splinting, and bone grafts, mobile teeth can be stabilised. Visit us as early as possible for the best outcomes.",
      },
      {
        q: "How do I prevent gum disease?",
        a: "Brush twice daily with proper technique, floss daily, use an antibacterial mouthwash, eat a balanced diet, avoid tobacco, and visit your dentist every 6 months for cleaning.",
      },
    ],
  },
  {
    slug: "dental-veneers-allahabad",
    name: "Dental Veneers",
    shortName: "Veneers",
    icon: "Layers",
    seoTitle:
      "Dental Veneers in Allahabad | Hollywood Smile Makeover – Lotus Family Dental",
    metaDescription:
      "Get a perfect Hollywood smile with porcelain dental veneers in Allahabad. Smile designer Dr. Monika Tiwari at Lotus Family Dental. Book today.",
    h1: "Premium Dental Veneers in Allahabad",
    tagline: "Hollywood Smile in Just 2 Visits.",
    coverImage:
      "https://i.pinimg.com/webp85/1200x/93/fc/50/93fc5085204e492faed232932c2d891a.webp",
    intro:
      "Dream of a flawless celebrity-style smile? Dental veneers are ultra-thin porcelain or composite shells bonded to the front of your teeth — instantly correcting colour, shape, chips, and gaps. Designed by smile artist Dr. Monika Tiwari at Lotus Family Dental, Allahabad, your dream smile is just 2 visits away.",
    symptoms: [
      "Stained or discoloured teeth",
      "Chipped or worn-down teeth",
      "Gaps between front teeth",
      "Slightly crooked teeth",
      "Asymmetrical smile",
      "Bridal / pre-wedding smile makeover",
    ],
    process: [
      {
        title: "Smile Design Consultation",
        text: "Digital smile design (DSD) software previews your new smile before any treatment starts.",
      },
      {
        title: "Minimal Tooth Preparation",
        text: "A very thin layer of enamel is shaped to fit the veneer — done under local anaesthesia.",
      },
      {
        title: "Custom Veneer Fabrication",
        text: "Precision impressions are sent to our lab. Hand-crafted porcelain veneers are made in 5–7 days.",
      },
      {
        title: "Bonding & Polish",
        text: "Veneers are bonded with strong dental adhesive, polished, and your perfect smile is ready.",
      },
    ],
    benefits: [
      "Hollywood-grade smile design",
      "Resistant to stains",
      "Looks completely natural",
      "Lasts 10–15+ years",
      "Quick — only 2 visits",
      "Bride-friendly fast-track service",
    ],
    faqs: [
      {
        q: "How much do dental veneers cost in Allahabad?",
        a: "Composite veneers at Lotus Family Dental cost ₹3,500–₹6,500 per tooth. Porcelain (Emax / Zirconia) veneers range from ₹12,000 to ₹22,000 per tooth based on the material and lab. A full upper smile makeover (8 veneers) starts from ₹1,00,000.",
      },
      {
        q: "How long do veneers last?",
        a: "High-quality porcelain veneers last 10 to 15 years with proper care. Composite veneers last 5 to 7 years. Avoid biting hard objects (nails, ice) and maintain regular dental check-ups.",
      },
      {
        q: "Are veneers permanent?",
        a: "Veneers are a permanent commitment because a thin layer of enamel is removed during preparation. They can be replaced when worn out, but the tooth always needs a covering after veneer preparation.",
      },
      {
        q: "Will veneers damage my teeth?",
        a: "When done by a trained smile designer, veneers preserve maximum tooth structure. We use minimal-prep techniques and digital smile design to ensure healthy, long-lasting results.",
      },
    ],
  },
  {
    slug: "dental-crowns-bridges-allahabad",
    name: "Dental Crowns & Bridges",
    shortName: "Crowns & Bridges",
    icon: "Crown",
    seoTitle:
      "Dental Crowns & Bridges in Allahabad | Zirconia, PFM, Emax – Lotus Family Dental",
    metaDescription:
      "Get premium dental crowns and bridges in Allahabad. Zirconia, PFM, Emax, and metal-free options. Lifetime warranty at Lotus Family Dental.",
    h1: "Premium Dental Crowns & Bridges in Allahabad",
    tagline: "Strong. Aesthetic. Lifetime Warranty.",
    coverImage:
      "https://i.pinimg.com/736x/fc/12/27/fc12272c2f040d13d6c8d55e52981127.jpg",
    intro:
      "A broken, root canal treated, or worn-down tooth needs a crown for protection. A missing tooth gap needs a bridge. At Lotus Family Dental, Allahabad, we offer the full range — zirconia, PFM (porcelain fused to metal), Emax, and metal-free crowns — designed by experts and crafted in premium dental labs. Lifetime warranty included.",
    symptoms: [
      "Cracked or broken tooth",
      "Post root canal treatment",
      "Large filling that keeps failing",
      "Worn-down tooth surface",
      "Missing tooth (needs bridge)",
      "Aesthetic crown replacement",
    ],
    process: [
      {
        title: "Tooth Evaluation",
        text: "X-rays and clinical examination determine the right crown / bridge material for your case.",
      },
      {
        title: "Tooth Preparation",
        text: "The tooth is shaped under local anaesthesia to receive the crown — painless 30 minute appointment.",
      },
      {
        title: "Digital / Conventional Impressions",
        text: "Precise impressions are taken and sent to the dental lab for custom fabrication in 5–7 days.",
      },
      {
        title: "Crown Cementation",
        text: "The crown is checked for fit, bite, and aesthetics, then permanently cemented. You walk out with a complete smile.",
      },
    ],
    benefits: [
      "Zirconia, PFM, Emax options",
      "Metal-free aesthetic crowns",
      "Lifetime warranty available",
      "Premium dental labs",
      "Natural tooth-like aesthetics",
      "Strong & long-lasting (15+ years)",
    ],
    faqs: [
      {
        q: "How much does a dental crown cost in Allahabad?",
        a: "PFM (Porcelain Fused to Metal) crown costs ₹3,500–₹5,500. Full Zirconia crown costs ₹8,000–₹15,000. Emax (lithium disilicate) crown costs ₹12,000–₹20,000. Bridges are priced per unit (each tooth).",
      },
      {
        q: "Which is the best dental crown material?",
        a: "Zirconia and Emax are the best — strong, aesthetic, and biocompatible. Zirconia is ideal for back teeth (high strength). Emax is best for front teeth (translucency). PFM is a budget-friendly option.",
      },
      {
        q: "How long do crowns and bridges last?",
        a: "High-quality crowns last 15 to 20+ years with proper oral hygiene. Bridges last 10 to 15 years. Avoid biting hard objects and visit your dentist every 6 months for cleaning and check-ups.",
      },
      {
        q: "Is the procedure painful?",
        a: "No. Tooth preparation is done under local anaesthesia — completely painless. After the crown is cemented, mild sensitivity for 1–2 days may occur but settles quickly.",
      },
    ],
  },
];

export const getServiceBySlug = (slug) => SERVICES.find((s) => s.slug === slug);
